import { render, staticRenderFns } from "./VirtualDoctorDashboardSba.vue?vue&type=template&id=0b5d9e04&scoped=true"
import script from "./VirtualDoctorDashboardSba.vue?vue&type=script&lang=js"
export * from "./VirtualDoctorDashboardSba.vue?vue&type=script&lang=js"
import style0 from "./VirtualDoctorDashboardSba.vue?vue&type=style&index=0&id=0b5d9e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5d9e04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCardText,VImg})
